import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
    static component = "photo-picker"
    static targets = ["input", "preview"]
    static values = { multiple: Boolean }

    connect() {
        super.connect()
    }

    disconnect() {
        super.disconnect()
    }

    // Called when user clicks the photo input field or button
    showPhotoPicker() {
        // Send message to native component
        this.send("show", {
            multiple: this.multipleValue
        }, (message) => {
            // Handle the response from native
            this.handlePhotoSelection(message.data)
        })
    }

    handlePhotoSelection(data) {
        if (data.images && data.images.length > 0) {
            // Update hidden input with base64 data
            if (this.hasInputTarget) {
                if (this.multipleValue) {
                    // For multiple images, you might want to handle differently
                    this.inputTarget.value = JSON.stringify(data.images)
                } else {
                    this.inputTarget.value = data.images[0]
                }

                // Trigger change event for form validation
                this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
            }

            // Update preview if target exists
            if (this.hasPreviewTarget) {
                this.updatePreview(data.images)
            }
        }
    }

    updatePreview(images) {
        this.previewTarget.innerHTML = ''

        images.forEach(imageData => {
            const img = document.createElement('img')
            img.src = `data:image/jpeg;base64,${imageData}`
            img.style.maxWidth = '100px'
            img.style.maxHeight = '100px'
            img.style.margin = '5px'
            img.style.borderRadius = '8px'
            this.previewTarget.appendChild(img)
        })
    }
}
